import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SkillsGridProps } from '../interfaces';
import { SkillCard } from './SkillCard';

export const SkillsGrid: React.FC<SkillsGridProps> = ({
  skills,
  currentPage,
  itemsPerPage,
  expandedSkills,
  searchQuery,
  getSubSkillsForSkill,
  onToggleExpand,
  onDeleteSkill,
  onDeleteSubSkill,
}) => {
  if (skills.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
          {searchQuery
            ? 'No skills found matching your search.'
            : 'No skills yet. Add one above!'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
        gap: 1.5,
        p: 2,
      }}
    >
      {skills.map((skill, index) => {
        const subSkills = getSubSkillsForSkill(skill.value);
        const isExpanded = expandedSkills.has(skill.value);

        return (
          <SkillCard
            key={skill.value}
            skill={skill}
            index={index}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            subSkills={subSkills}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            onDeleteSkill={onDeleteSkill}
            onDeleteSubSkill={onDeleteSubSkill}
          />
        );
      })}
    </Box>
  );
};

